import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "@/features/home/styles/Home.css?vue&type=style&index=0&id=ad8ad272&scoped=true&lang=css&external"
import "@/features/home/styles/HomeComics.css?vue&type=style&index=1&id=ad8ad272&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad8ad272"]])

export default __exports__